// Copied from platform-app components/pos/layout/DiscountPopupPreview.tsx on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
import React from 'react';
import { PREVIEW_PALETTE, type PreviewTheme } from './previewPalette';

export interface DiscountPopupPreviewProps {
  enabled: boolean;
  percentage: number | '';
  theme: PreviewTheme;
}

export default function DiscountPopupPreview({ enabled, percentage, theme }: DiscountPopupPreviewProps) {
  const pct = percentage === '' ? 0 : percentage;
  const p = PREVIEW_PALETTE[theme];
  return (
    <div className="w-full max-w-[320px] sm:w-[320px] rounded-2xl border px-6 py-5 text-center" style={{ background: p.body, borderColor: p.headBor }}>
      <div className="mb-3 text-lg font-bold" style={{ color: p.tx }}>Discount</div>
      {enabled && pct > 0 && (
        <button
          type="button"
          disabled
          className="mb-4 w-full rounded-[10px] py-3.5 text-[15px] font-bold"
          style={{ background: p.addBg, color: p.addTx }}
        >
          Employee Discount ({pct}%)
        </button>
      )}
      <div className="mb-3.5 flex gap-1.5 rounded-[10px] p-1" style={{ background: p.input }}>
        <div className="flex-1 rounded-[8px] border py-2 text-[13px] font-bold" style={{ background: p.body, borderColor: p.keyBor, color: p.tx }}>Percentage</div>
        <div className="flex-1 rounded-[8px] border border-transparent py-2 text-[13px] font-bold" style={{ color: p.mu }}>Amount</div>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {['5%', '10%', '15%', '20%', '25%'].map((v) => (
          <div key={v} className="rounded-[10px] border py-3.5 text-[17px] font-extrabold" style={{ background: p.key, borderColor: p.keyBor, color: p.tx }}>{v}</div>
        ))}
        <div className="rounded-[10px] border py-3.5 text-[13px] font-bold" style={{ background: p.key, borderColor: p.keyBor, color: p.mu }}>Custom</div>
      </div>
    </div>
  );
}
